"use client";

import { createBrowserClient } from "@supabase/ssr";
import { getPublicSupabaseEnv } from "@/lib/env";
import { authDebug } from "@/lib/auth-debug";
import { getSupabaseCookieOptions } from "./cookies";
import type { Database } from "./types";

let browserClient: ReturnType<typeof createBrowserClient<Database>> | null = null;

export function createSupabaseBrowserClient() {
  const { url, anonKey } = getPublicSupabaseEnv();
  const supabaseHost = (() => {
    try {
      return new URL(url).host;
    } catch {
      return "invalid-url";
    }
  })();

  if (browserClient) {
    authDebug("[supabase-browser] reusing client", {
      supabaseUrl: url,
      supabaseHost,
      authEndpoint: `${url}/auth/v1`,
      hasAnonKey: Boolean(anonKey),
      persistSession: true,
      sessionStorage: "document.cookie",
      clientConfigVersion: "supabase-ssr-cookie-v1"
    });
    return browserClient;
  }

  authDebug("[supabase-browser] creating client", {
    supabaseUrl: url,
    supabaseHost,
    authEndpoint: `${url}/auth/v1`,
    hasAnonKey: Boolean(anonKey),
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    sessionStorage: "document.cookie",
    clientConfigVersion: "supabase-ssr-cookie-v1"
  });

  browserClient = createBrowserClient<Database>(url, anonKey, {
    cookieOptions: getSupabaseCookieOptions(),
    auth: {
      autoRefreshToken: true,
      detectSessionInUrl: true,
      persistSession: true
    },
    isSingleton: true
  });

  return browserClient;
}
